import React, { useContext } from 'react'
import 'stylesheets/TimerAppStyles/TodoSearch.css'
import { TodoContext } from 'contexts/TimerAppContexts/TodoContext';

const TodoSearch = () => {
    const {searchValue, setSearchValue} = useContext(TodoContext);
    return (
        <input 
            placeholder='Guitar Lesson at 5pm' 
            className='searcher'
            value={searchValue}
            onChange={(e)=>{
                setSearchValue(e.target.value)
            }}
        />
    )
}

export { TodoSearch }